import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, masterOnly = false }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-canvas" data-testid="auth-loading">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  if (user === false) return <Navigate to="/login" replace />;
  if (masterOnly && user.role !== "master") return <Navigate to="/menu" replace />;
  if (adminOnly && !["admin", "master"].includes(user.role)) return <Navigate to="/menu" replace />;

  return children;
};
